<template>
  <div id="app">
    <header id="app_header">
      <el-row type="flex" align="middle">
        <el-col :span="2"
          ><img id="app-logo" alt="logo" src="./assets/logo.png"/>
        </el-col>
        <el-col :span="2"
        ><img  class="app-logo" alt="logo" src="./assets/logo-right.png"/>
        </el-col>
        <el-col :xl="17" :span="18" :xs="22">
          <nav class="header-menu-bar hidden-xs-only">
            <a
              class="header-menu-item"
              :class="{ active: i == $store.state.currentMenuI }"
              v-for="(v, i) in menuList"
              :key="i"
              @click="goPage(v)"
              >{{ v.cnName }}</a
            >
          </nav>
          <div class="header-menu-btn hidden-sm-and-up">
            <div
              class="header-menu-open"
              :class="{ active: menuShow }"
              @click="openMenu"
            >
              <span class="hamburger"></span>
            </div>
          </div>
        </el-col>
        <el-col :xl="5" :span="4" class="hidden-xs-only">
          <div class="right-bar">
            <span v-show="!searchShow">
                <a @click="switchLang('en')">ENGLISH</a>
                <a @click="switchLang('cn')">简体</a>
                <img class="search-icon" @click.stop="showSearch" alt="search" src="./assets/icon-search.png">
                <!-- <i @click.stop="showSearch" class="el-icon-search search-icon"></i> -->
            </span>
            
            <el-input  v-if="searchShow"  @keyup.enter.native="toNewsPage" class="header-search" placeholder="搜索" v-model="searchText">
               <!-- <i @click.stop="toNewsPage" slot="suffix" class="el-input__icon el-icon-search"></i> -->
               <img class="search-icon icon-search"  slot="suffix" @click.stop="toNewsPage" alt="search" src="./assets/search-index-icon.png">
            </el-input>
            <!-- <img alt="search" src="./assets/search-icon.png"> -->
          </div>
        </el-col>
      </el-row>
    </header>
    <div :class="{ 'header-wrap': menuShow }" @click="openMenu"></div>
    <nav class="header-menu" :class="{ active: menuShow }">
      <div
        class="header-menu-close"
        :class="{ active: menuShow }"
        @click="openMenu"
      >
        <span class="cross"></span>
      </div>
      <div class="search-input search-border">
        <div class="input-text">
          <el-input clearable placeholder="搜索" v-model="searchText">
          </el-input>
        </div>
        <div class="input-icon" @click.stop="toNewsPage">
          <!-- <i class="el-icon-search search-icon"></i> -->
          <img alt="search" class="search-icon" src="./assets/search-icon.png">
        </div>
      </div>
      <div class="search-border" v-for="(v) in menuList" :key="v.cnName">
        <a class="header-menu-v-item active" @click="goPage(v)">{{
          v.cnName
        }}</a>
      </div>
      <div class="search-border">
        <a v-if="lang === 'cn'" class="header-menu-v-item active" @click="switchLang('en')">ENGLISH</a>
        <a v-if="lang === 'en'" class="header-menu-v-item active" @click="switchLang('cn')">简体中文</a>
      </div>
    </nav>

    <div id="app_content">
      <router-view></router-view>
    </div>
    <footer id="app_footer">
      <img src="./assets/qrcode.png" alt="qrcode" />
      <nav class="footer-menu">
        <a class="footer-menu-item mr30" @click="toMedia">新闻公布</a>
        <i class="dot hidden-xs-only"></i>
        <a class="footer-menu-item mr30" @click="ToNewPage('getJoin')"
          >加入我们</a
        >
        <i class="dot hidden-xs-only"></i>
        <a class="footer-menu-item mr30" @click="ToNewPage('getPartners')"
          >合作伙伴</a
        >
        <i class="dot hidden-xs-only"></i>
        <a class="footer-menu-item" @click="ToNewPage('getLaw')"
          >法律声明及隐私政策</a
        >
      </nav>
      <div class="footer-text">
        ©2020 天津市荣程普济基金会 版权所有 
       
       <img class="beian" src="./assets/beian.png" alt="备案">
        <a style="color:#b3b3b3;margin-left:3px;" href="https://beian.miit.gov.cn" target="_blank">津ICP备20005624号</a>
      </div>
      <div class="footer-text">邮箱：rockpuji@163.com</div>
      <div class="footer-text">联系电话：022-66286932</div>
      <div class="footer-text">融和互联 技术支持</div>
    </footer>
  </div>
</template>

<script>
import { getColumns } from "./api/home";

export default {
  name: "app",
  data() {
    return {
      menuList: [],
      menuShow: false,
      searchText: "",
      searchShow: false,
      lang: 'cn'
    };
  },
  mounted() {
    getColumns().then((res) => {
      // targetUrl cnName
      if (res) {
        this.menuList = res;
      }
    });
  },
  methods: {
    openMenu() {
      this.menuShow = !this.menuShow;
    },
    goPage(pData) {
      let _params = pData.targetUrl == "/" ? "" : `/${pData.colId}/`;
      this.$router.push(pData.targetUrl + _params);
      this.menuShow = false;
      this.$store.state.newsTabI = 0
    },
    toMedia() {
      let pData = this.menuList.filter(
        (value) => value.cnName === "媒体报道"
      )[0];
      this.goPage(pData);
    },
    ToNewPage(pageName) {
      this.$router.push("/partners/102/" + pageName);
    },
    switchLang() {
      // this.lang = name
      // localStorage.setItem("langType", name);
      // this.$i18n.locale = name;
      // this.menuShow = false
      // window.location.reload()
    },
    showSearch(){
      this.searchShow = true
    },
    toNewsPage () {
      this.searchShow = false
      this.menuShow = false
      if(!this.searchText) {
        return;
      }
      this.$router.push(`/search/${this.searchText}`)
      this.searchText = ''
    }
  },
};
</script>

<style lang="scss">
#app_content {
  min-height: 300px;
}
a {
  text-decoration: none;
}
h1,h2,h3{
  font-weight: 300;
}
.el-input__inner{
  border-radius: 0!important;
}
.note-video-clip {
  width: 100%;
}
.home-title {
  margin: rem(70) 0; // 119
  text-align: center;
  .sub-title {
    display: block;
    color: #999999;
  }
}
.detail-btn {
  display: block;
  text-align: center;
  color: #ffffff;
  background-color: #05459c;
  cursor: pointer;
}
.crumbs {
  box-sizing: border-box;
  margin: rem(40) auto rem(100) auto;
  padding: 0 rem(32);
  width: rem(1471);
  height: rem(75);
  line-height: rem(75);
  border-radius: rem(37.5);
  font-size: rem(24);
  color: #999999;
  background-color: #f2f2f2;
  a {
    color: #999999;
  }
  span.active {
    cursor: pointer;
  }
}
.battle-tab {
  border-bottom: 3px solid #e4ecf5;
  .tab-item {
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    background-color: #dfe9f4;
    cursor: pointer;
  }
  .tab-item.active {
    color: #ffffff;
    background-color: #05459c;
  }
}
.battle-tab.green {
  border-bottom: 3px solid #f6f8f5;
  .tab-item {
    background-color: #eaf4ec;
  }
  .tab-item.active {
    background-color: #016b45;
  }
}
.battle-tab.red {
  border-bottom: 3px solid #f0e7e8;
  .tab-item {
    background-color: #f0e7e8;
  }
  .tab-item.active {
    background-color: #b50627;
  }
}
.swiper-pagination-bullet-active {
  background: #fff!important;
}
#app_footer{
  .beian{
    display:inline-block;
    width:16px;
    height:16px;
    margin:0 0 0 10px;
    position:relative;
    top:2px;
  }
}

.project-list {
  display: flex;
  flex-flow: wrap;
  .project-item {
    position: relative;
    .bg-img {
      box-shadow: 2px 2px 5px #cccccc;
    }
    .project-title {
      //position: absolute;
      //bottom: 0;
      box-sizing: border-box;
      margin: 30px 20px 0 0;
      width: calc(100% - 40px);
      text-align: left;
      color: #999999;
      transition: bottom 0.8s;
      z-index: 2;
    }
    .shade-btn {
      position: absolute;
      display: none;
      top: 0;
      width: 100%;
      background-color: rgba(#ffffff, 0.9);
      z-index: 1;
      animation: 1s fadeInOut;
      .ds-btn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: rem(120);
        display: block;
        margin: auto;
        width: rem(148);
        height: rem(49);
        border-radius: rem(25);
        line-height: rem(49);
        text-align: center;
        color: #fff;
        background-color: #b50627;
      }
    }
  }
}
.project-pagination-wrap {
  text-align: center;
  padding: 20px 0;
}
#app_header {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  z-index: 9;
  .header-menu-bar {
    text-align: right;
    .header-menu-item {
      margin-left: rem(60);
      font-size: 20px;
      font-weight: 400;
      color: #4d4d4d;
    }
    .header-menu-item:hover {
      cursor: pointer;
      color: $main-color;
    }
    .header-menu-item.active {
      font-weight: 500;
      color: $main-color;
    }
  }
  .right-bar {
    text-align: right;
    font-size: 15px;
    a {
      display: inline-block;
      margin-right: rem(15);
      line-height: rem(30);
      font-weight: bold;
      color: #4d4d4d;
      cursor: pointer;
    }
    .search-icon {
      position: relative;
      top: 3px;
      color: #2dbc7e;
      cursor: pointer;
      transform: scale(.9);
    }
    .icon-search {
      width: 40px;
      transform: scale(.7);
    }
    img {
      vertical-align: bottom;
    }
  }
  .header-menu-btn {
    position: relative;
    height: 0.35rem;
    .header-menu-open {
      position: absolute;
      display: inline-block;
      right: 0;
      width: 0.4rem;
      height: 100%;
      overflow: hidden;
      .hamburger,
      .hamburger::after,
      .hamburger::before {
        content: "";
        position: absolute;
        display: block;
        top: 0.15rem;
        left: 0;
        width: 100%;
        height: 0.05rem;
        background-color: #00653e;
        transition: all 0.9s;
        transition-timing-function: cubic-bezier(0.6, 0, 0.2, 1);
        transition-delay: 0.15s;
      }
      .hamburger::before {
        top: -0.15rem;
      }
      .hamburger::after {
        top: 0.15rem;
      }
    }
    .header-menu-open.active {
      .hamburger,
      .hamburger::after,
      .hamburger::before {
        left: 100%;
      }
    }
  }
}
.header-nav {
  padding: 0 rem(75);
  height: 64px;
  background: #f2f2f2;
  line-height: 64px;
  color: #4d4d4d;
  border-bottom: 8px solid #03653e;
  .color-nav {
    color: #5a5a5a;
  }
  .tab-item {
    color: #333;
    
    &:hover{
      cursor: pointer;
      color:#00653E;
    }
  }
  .tab-item.active {
    color:#00653E;
  }
}
.nav-wrap {
    padding: 0 rem(75);
    .nav-title {
      height: 130px;
      line-height: 130px;
      border-bottom: 1px solid #bfbfbf;
      font-size: rem(45);
      font-weight: 300;
    }
}
.swiper-pagination-bullet{
      width: 12px!important;
      height: 12px!important;
}
:focus{
      outline: none!important;
}
@media only screen and (min-width: 768px) {
  html {
    min-width: 1200px;
  }
  #app_header {
    padding: rem(25) rem(75);
    min-width: 1200px;
    height: rem(135);
    #app-logo {
      width: rem(90);
    }
    .app-logo {
      width: rem(230);
    }
  }
  #app_content {
    padding-top: rem(135);
  }
  .home-title {
    font-size: rem(60);
    .sub-title {
      font-size: rem(24);
    }
  }
  
  .header-search {
    width: 60%!important;
    i{
      cursor:pointer;
      font-size: 20px;
    }
  }
  :root {
    --swiper-navigation-size: 30px!important;
  }
  .header-nav{
    .tab-item{
      margin-right: 35px;
    }
  }
  .detail-btn {
    width: rem(277);
    height: rem(65);
    line-height: rem(65);
    border-radius: rem(32.5);
    font-size: rem(26);
  }
  .page-banner0 {
    height: rem(252); // 772
  }
  .page-banner1 {
    height: rem(252); // 411 772
  }
  .battle-tab {
    margin-bottom: rem(90);
    .tab-item {
      padding: rem(16);
      min-width: rem(160);
      font-size: rem(24);
    }
  }
  .border-right {
    border-right: 1px solid #bfbfbf;
  }
  
  .project-list {
    //justify-content: space-between;
    justify-content: start;
    .project-item {
      padding-right: rem(30);
      margin-right: rem(30);
      //margin-bottom: rem(43);
      margin-top: rem(43);
      width: rem(523);
      .bg-img {
        height: rem(340);
        //border-radius: rem(48);
      }
      .shade-btn {
        height: rem(400);
        //border-radius: rem(48);
      }
      .project-title {
        font-size: rem(18);
        max-height: rem(116);
      }
      .project-title-xs {
        display: none;
      }
    }
    .project-item:nth-child(3n) {
      margin-right: 0!important;
      padding-right: 0!important;
    }
    .bg-img {
      transition: all 1s;
    }
    .project-item:hover {
      cursor: pointer;
      // .bg-img {
      //   transform: scale(1.2);
      // }
    }
    // .project-item:hover {
    //   cursor: pointer;
    //   .project-title {
    //     bottom: rem(220);
    //     color: #000;
    //   }
    //   .shade-btn {
    //     display: block;
    //   }
    // }
  }
  .pro-index {
    .project-item {
      padding-right: rem(45);
      margin-right: rem(40);
    }
  }
  // #list_page {
  //   .project-item {
  //      padding-right: rem(30);
  //      margin-right: rem(30);
  //   }
  // }
  .news-wrap {
      .border-bottom {
        border-bottom: 1px solid #bfbfbf;
      }
      .border-right {
        border-right: 1px solid #bfbfbf;
      }
      display: flex;
      padding: 0 rem(75);
      .news-list-item-wrap {
        width: 70%;
      }
      .news-list-item {
        display: flex;
        border-bottom: 1px solid #bfbfbf;
        margin:0 rem(60) 20px 0;
        padding-bottom: 30px;
        height: rem(270);
        cursor: pointer;
        .news-list-item-img {
          width: 50%;
          padding-right: rem(80)
        }
        .news-list-item-text {
          width: 50%;
          .title {
            font-size: rem(26);
            margin-bottom: 20px;
          }
          .subTitle {
            color:#808080;
            font-size: rem(20);
          }
        }
      }
      .news-list-trends {
        width: 30%;
        padding:0 rem(30) 0 rem(60);
        margin-bottom: 10px;
        cursor: pointer;
        .new-trends-item {
          //height: rem(140);
          padding-bottom: rem(30);
          margin-bottom: rem(30);
          .title {
            font-size: rem(22);
            margin-bottom: 20px;
          }
          .described {
            font-size: rem(18);
            font-family: 'Source Han Sans SC';
            font-weight: 400;
            color: #999999;
            line-height: 30px;
          }
        }
        .list-title {
          font-size: rem(35);
          margin: 0;
          text-align: center;
        }
        .title {
          color: #4D4D4D;
          line-height: rem(37)
        }
        .described {
          color: #999999;
        }
      }
    }
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.header-menu {
  position: fixed;
  top: 0;
  left: 100%;
  box-sizing: border-box;
  width: 0%;
  height: 100%;
  overflow: hidden;
  transition: all 0.6s;
  background-color: #f2f2f2;
  z-index: 1000;
  padding: 20px;
  .header-menu-v-item {
    display: block;
    //padding: 8px 16px;
    padding: 8px 0px;
    width: 100%;
    font-size: 18px;
    white-space: nowrap;
  }
  .header-menu-close {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    width: 0.4rem;
    height: 0.35rem;
    .cross::before,
    .cross::after {
      content: "";
      position: absolute;
      top: 0.15rem;
      display: block;
      width: 100%;
      height: 0.05rem;
      background-color: #000;
      transition: all 0.3s;
      transition-timing-function: cubic-bezier(0.6, 0, 0.2, 1);
    }
    .cross::before {
      transform: translateY(-70px) translateX(-70px) rotate(45deg);
    }
    .cross::after {
      transform: translateY(-70px) translateX(70px) rotate(-45deg);
      transition-delay: 0.15s;
    }
  }
  // .header-menu-close.active {
  //   .cross::before {
  //     transform: rotate(45deg);
  //   }
  //   .cross::after {
  //     transform: rotate(-45deg);
  //   }
  // }
  .search-border {
    border-bottom: 1px solid #e8e8e8;
  }
  .search-input {
    display: flex;
    justify-content: space-around;
    padding-bottom: 10px;
    align-items: center;
    .input-text {
      width: 80%;
      .el-input__inner {
        border: none;
      }
    }
    .el-input__inner {
      border-radius: 0;
    }
    .input-icon {
      width: 20%;
      text-align:right;
      img{
        position:relative;
        top: 3px;
      }
    }
  }
}
.header-menu.active {
  left: 20%; // 0
  width: 80%; // 100%
}
.header-wrap {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}
#app_footer {
  text-align: center;
  color: #b3b3b3;
  background-color: #1c202b;
  padding-bottom: rem(80);
  img {
    margin: 50px 0;
  }
  .dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #b3b3b3;
    margin-right: 30px;
    position: relative;
    top: -6px;
  }
  .footer-menu {
    padding-bottom: 0.1rem;
    .footer-menu-item {
      cursor: pointer;
      font-size: 20px;
    }
  }
  .footer-menu-item.mr30 {
    margin-right: 30px;
  }
  .footer-text {
    padding: 8px 0;
  }
}
@media only screen and (max-width: 768px) {
  #app_header {
    padding: 0.2rem 0.25rem;
    height: 1rem;
    #app-logo {
      width: 0.6rem;
    }
    .app-logo {
      width: 1.5rem;
      margin-left:.2rem;
    }
  }
  #app_content {
    padding-top: 1rem;
    min-height: 7.5rem;
  }
  .header-nav {
    border-bottom: 5px solid #03653e;
    display: flex;
    overflow-y: hidden;
    flex-wrap: nowrap;
    .tab-item {
      font-size: 15px!important;
      white-space: nowrap;
      padding: 0 15px;
    }
    .tab-item:nth-child(1){
      padding-left: 0;
    }
  }
  .nav-wrap {
    padding: 0 rem(75);
    .nav-title {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #bfbfbf;
      font-size: 18px;
    }
  }
  .home-title {
    font-size: 0.6rem;
    .sub-title {
      font-size: 0.24rem;
    }
  }
  .detail-btn {
    width: 2.14rem;
    height: 0.51rem;
    line-height: 0.51rem;
    border-radius: 0.25rem;
    font-size: 0.24rem;
  }
  .page-banner0,
  .page-banner1 {
    height: 4.81rem;
  }
  .battle-tab {
    margin-bottom: 0.9rem;
    .tab-item {
      padding: 0.16rem;
      min-width: 1.6rem;
      font-size: 0.3rem;
    }
  }
  :root {
      --swiper-navigation-size: 30px!important;
  }
  
  .project-list {
    .project-item {
      padding-right: 0.44rem;
      //margin-bottom: .44rem;
      margin-top: 0.44rem;
      width: 2.95rem;
      .bg-img {
        height: 2.64rem;

        //border-radius: .25rem;
      }
      .project-title-xs {
        padding-top: 0.36rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #999999;
        line-height: 0.4rem;
      }
    }
    .project-item:nth-child(2n) {
      //margin-right: 0;
      padding-right: 0;
    }
    
  }
  .project-mobile {
      .project-item {
        border-bottom: 1px solid #bfbfbf;
        padding-bottom: 20px;
      }
      .border-0 {
        border-bottom: none;
      }
      
  }
  
  #app_footer {
    img {
      margin: 50px 0 40px 0;
    }
    .footer-menu {
      .footer-menu-item {
        font-size: 0.28rem;
      }
    }
    .footer-menu-item.mr30 {
      margin-right: 15px;
    }
    .footer-text {
      font-size: 0.24rem;
    }
  }
   .news-list-item-wrap {
        padding-bottom: .4rem;
        .news-list-item {
          padding-bottom: .5rem;
          margin-bottom: .5rem;
        }
        .news-list-item-img {
          margin-bottom: .3rem;
        }
        .news-list-item-text {
          .flex {
            justify-content: space-between;
            .detail {
              color: #00653E;
              font-size: .23rem;
            }
          }
          .title {
            font-size: .3rem;
            font-weight: 500;
            color: #333333;
            margin-bottom: .2rem;
          }
          .subTitle{
            color:#999999;
            //width: 50%;
            font-size: 12px;
            //max-width: 50%;
          }
        }
  }
}
</style>

